// extracted by css-extract-rspack-plugin
export default {"badge":"WOlIxNdWV8J7pq5b","badge-fade-in":"nXXRFr4WWZEdq8Jh","countNumber":"wDvbKDjaOkTc0SnW","item":"Z_AiR2sofEy0dHhi","fade-in":"cHcXh4fkcUMxr39y","list":"am1z_X2WplQILLkc"};